import React, { useState, useEffect } from 'react';

const CoreOfferings = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    // Trigger entrance animation
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const offerings = [
    {
      id: 1,
      icon: '📚',
      title: 'Student Memberships',
      description: 'Access courses, resources, and global AI community'
    },
    {
      id: 2,
      icon: '🏛️',
      title: 'University Partnerships',
      description: 'Collaborative programs with leading institutions'
    },
    {
      id: 3,
      icon: '🔧',
      title: 'AI Workshops',
      description: 'Hands-on training sessions and skill-building'
    },
    {
      id: 4,
      icon: '📄',
      title: 'AI Publications',
      description: 'Research papers, guides, and educational content'
    },
    {
      id: 5,
      icon: '🌐',
      title: 'Global Internships',
      description: 'International AI internship opportunities'
    },
    {
      id: 6,
      icon: '🏢',
      title: 'Industry Visits',
      description: 'Exclusive access to AI companies and labs'
    }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={{
          ...styles.title,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.8s ease-out'
        }}>
          Core Offerings
        </h1>
        <p style={{
          ...styles.subtitle,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.8s ease-out 0.2s'
        }}>
          Comprehensive AI education programs designed for every learner, educator, and
          institution worldwide.
        </p>
        <div style={styles.grid}>
          {offerings.map((offering, index) => (
            <div
              key={offering.id}
              style={{
                ...styles.card,
                transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.9)',
                opacity: isVisible ? 1 : 0,
                transition: `all 0.6s ease-out ${0.1 * (index + 1)}s`,
                ...(hoveredCard === offering.id ? styles.cardHover : {})
              }}
              onMouseEnter={() => setHoveredCard(offering.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={styles.iconContainer}>
                <span style={{
                  ...styles.icon,
                  transform: hoveredCard === offering.id ? 'scale(1.2) rotate(5deg)' : 'scale(1) rotate(0deg)',
                  transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                }}>
                  {offering.icon}
                </span>
              </div>
              <h3 style={{
                ...styles.cardTitle,
                transform: hoveredCard === offering.id ? 'translateY(-2px)' : 'translateY(0)',
                transition: 'all 0.3s ease'
              }}>
                {offering.title}
              </h3>
              <p style={{
                ...styles.cardDescription,
                transform: hoveredCard === offering.id ? 'translateY(-1px)' : 'translateY(0)',
                transition: 'all 0.3s ease 0.1s'
              }}>
                {offering.description}
              </p>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    padding: '60px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#2c3e50',
    textAlign: 'center',
    marginBottom: '16px',
    letterSpacing: '-0.02em'
  },
  subtitle: {
    fontSize: '18px',
    color: '#5a6c7d',
    textAlign: 'center',
    maxWidth: '600px',
    margin: '0 auto 60px',
    lineHeight: '1.6'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '32px',
    alignItems: 'stretch'
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    padding: '32px 24px 20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    backdropFilter: 'blur(10px)',
    position: 'relative',
    overflow: 'hidden'
  },
  cardHover: {
    transform: 'translateY(-8px) scale(1.02)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    backgroundColor: 'rgba(255, 255, 255, 1)'
  },
  iconContainer: {
    marginBottom: '20px',
    padding: '10px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, rgba(74, 144, 226, 0.1) 0%, rgba(80, 200, 120, 0.1) 100%)'
  },
  icon: {
    fontSize: '40px',
    display: 'block',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#2c3e50',
    marginBottom: '12px',
    margin: '0 0 12px 0'
  },
  cardDescription: {
    fontSize: '15px',
    color: '#5a6c7d',
    lineHeight: '1.5',
    marginBottom: '0',
    flex: '1',
                    margin: '0'
  },
  buttonContainer: {
    width: '100%'
  },
  button: {
    backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    border: 'none',
    borderRadius: '25px',
    padding: '12px 28px',
    fontSize: '14px',
    fontWeight: '600',
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    width: '100%'
  }
};

export default CoreOfferings;